import React from 'react';
import { motion } from 'framer-motion';
import { GiftIcon } from 'lucide-react';
const bonuses = [{
  n: '01',
  title: 'Kit WhatsApp "Turno Confirmado"',
  desc: 'Mensajes listos para copiar, pegar y enviar. Convertí cada consulta tibia en una seña confirmada.',
  price: '$14.990'
}, {
  n: '02',
  title: 'Planificador Agenda 6 Días',
  desc: 'Organizá tu semana como una profesional y detectá exactamente dónde estás perdiendo plata.',
  price: '$9.990'
}, {
  n: '03',
  title: 'Checklist Instagram Lash que Vende',
  desc: 'Transformá tu perfil en una vidriera clara, confiable y lista para recibir consultas a diario.',
  price: '$7.990'
}, {
  n: '04',
  title: 'Mini Guía Fotos Lash con Celular',
  desc: 'Sacá fotos más prolijas de tus trabajos para que tus resultados vendan por vos, sin cámara pro.',
  price: '$7.990'
}, {
  n: '05',
  title: 'Workbook Clienta Fija',
  desc: 'Convertí una clienta ocasional en una clienta que vuelve, recomienda y sostiene tu agenda sola.',
  price: '$5.990'
}];
export function Bonuses() {
  return <section aria-label="Bonos" className="bg-ink-2 border-y border-white/5" data-id="element-14" data-mp="3iclnrsv34kyc">
      <div className="mx-auto max-w-5xl px-5 py-20 pt-[0px] pb-[22px]" data-id="element-15" data-mp="3dek5ha5hgpnx">
        <h2 className="text-center font-display text-3xl font-black text-white sm:text-4xl pt-[8px]" data-id="element-16" data-mp="3r79ttl8hi6o7">
          🎁 5 Bonos estratégicos
        </h2>
        

        <div className="mt-12 grid gap-5 sm:grid-cols-2" data-id="element-17" data-mp="3n79abm6j35aa">
          {bonuses.map((b, i) => <motion.div key={b.n} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.4,
          delay: i % 2 * 0.08
        }} className="relative flex flex-col rounded-2xl border border-gold/20 bg-ink p-6 pb-[0px] pt-[5px]" data-id="element-18" data-mp="2zfu77r6xgjxz" data-mpi={i}>
              <div className="mb-3 flex items-center justify-between" data-id="element-19" data-mp="33ja32lb6ag9m">
                <span className="inline-flex items-center gap-1.5 rounded-full bg-gold/15 px-3 py-1 text-xs font-bold text-gold" data-id="element-20" data-mp="noq5uuwu9mz7">
                  <GiftIcon className="h-3.5 w-3.5" data-id="element-21" data-mp="it188x4dqg5j" /> Bono {b.n}
                </span>
                <span className="text-sm font-bold" data-id="element-22" data-mp="3cin1z4bsngei">
                  <span className="text-white/40 line-through" data-id="element-23" data-mp="3hh8273r1q02y">{b.price}</span>{' '}
                  <span className="text-rose-soft" data-id="element-24" data-mp="3ljunelt7omr6">GRATIS</span>
                </span>
              </div>
              <h3 className="text-base font-bold text-white" data-id="element-25" data-mp="3qj7jzy9vx86y">{b.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-white/60" data-id="element-26" data-mp="3qgbijzytw1dr">{b.desc}</p>
            </motion.div>)}
        </div>

        <div className="mt-10 rounded-2xl border border-rose/30 bg-rose/10 p-6 text-center" data-id="element-27" data-mp="2xtig9d5siu1n">
          <p className="text-base font-bold text-white sm:text-lg" data-id="element-28" data-mp="32td6rflnlhm6">
            Valor total de los bonos:{' '}
            <span className="text-white/50 line-through" data-id="element-29" data-mp="37k3citxzrmhe">$46.950</span>{' '}
            <span className="text-rose-soft" data-id="element-30" data-mp="2a4fp9ep9nouh">HOY GRATIS CON TU MEGAPACK</span>
          </p>
        </div>
      </div>
    </section>;
}